import { useEffect, useState } from 'react';
import { commonFetchApi } from '@/fetch/bussiness/common';
import { HttpStatusCode } from '@/fetch/core/constant';
import { CommonEnumKey } from '../enum';
import { FormatEnumListMap } from '../type';

/**
 * 格式化枚举列表
 * @param {Record<string, any>} list
 * @return {*}
 */
const formatEnum = (list: Record<string, any>) => {
  const formattedEnumMap = Object.entries(list).reduce(
    (acc: any, [enumKey, enumList]) => {
      const key = enumKey as keyof FormatEnumListMap;
      acc[key] = (enumList || []).map((item: { code: any; name: string }) => ({
        label: item.name,
        value: item.code,
      }));
      return acc;
    },
    {}
  ) as FormatEnumListMap;
  return formattedEnumMap;
};

/**
 * 获取全局公共枚举列表
 * @param {CommonEnumKey[]} keyList
 * @return {*}
 */
const UseGetCommonEnumMap = (keyList: CommonEnumKey[]) => {
  const enumListFromStorage = localStorage.getItem('ENUM_LIST_MAP'); // localStorage里的枚举列表
  const [enumMap, setEnumMap] = useState<FormatEnumListMap>(
    {} as FormatEnumListMap
  ); // 格式化之后的枚举列表
  const [loadingEnumMap, setLoadingEnumMap] = useState<boolean>(false); // 枚举列表是否正在加载

  /**
   * 获取枚举列表
   * 先从localStorage中获取，如果没有，则从后端获取
   */
  const getCommonDropDown = async () => {
    try {
      setLoadingEnumMap(true);
      let basicEnumMapList: Record<string, any> = {};
      if (enumListFromStorage) {
        // 先从localStorage中获取
        try {
          basicEnumMapList = JSON.parse(enumListFromStorage);
        } catch (_) {
          basicEnumMapList = {};
        }
      } else {
        // 无则从后端获取
        const res = await commonFetchApi.getEnumListMap(keyList);
        if (res && res.code === HttpStatusCode.Success && res.data) {
          basicEnumMapList = res.data;
        }
      }
      const formattedEnumMap = formatEnum(basicEnumMapList);
      setEnumMap(formattedEnumMap);
    } catch (_) {
    } finally {
      setLoadingEnumMap(false);
    }
  };

  /**
   * 页面挂载--获取枚举列表
   */
  useEffect(() => {
    if (keyList?.length > 0) {
      getCommonDropDown();
    }
  }, [JSON.stringify(keyList), enumListFromStorage]);

  return { enumMap, loadingEnumMap };
};

export default UseGetCommonEnumMap;
